"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("../../utils/defaultDevExtremeGridComponents"));
var AddEditRoleDialog_1 = __importDefault(require("./AddEditRoleDialog"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var rolesSlice_1 = require("src/features/roles/rolesSlice");
function Roles() {
    var data = (0, reduxHooks_1.useAppSelector)(function (state) { return state.roles; }).data;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)("Warehouse Roles");
    (0, react_1.useEffect)(function () {
        dispatch((0, rolesSlice_1.fetchRolesInBatches)());
        var unsubscribe = (0, rolesSlice_1.subscribeToRoles)(dispatch);
        return function () {
            unsubscribe();
        };
    }, [dispatch]);
    var _a = (0, react_1.useState)({}), role = _a[0], setRole = _a[1];
    var _b = (0, react_1.useState)(false), modal = _b[0], setModal = _b[1];
    var _c = (0, react_1.useState)(""), type = _c[0], setType = _c[1];
    var dataSource = data;
    var columns = [
        { name: "title", title: "Title" },
        {
            name: "id",
            title: t("common.actions"),
            key: "id",
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                var _this = this;
                return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () {
                                    setType("edit");
                                    setRole(row);
                                    setModal(true);
                                }, type: "primary", style: { margin: "0px 5px" } }, { children: t("common.edit") })) }), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Are you sure?", okText: "Yes", cancelText: "No", onConfirm: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        dispatch((0, rolesSlice_1.deleteRole)(row.id));
                                        return [2 /*return*/];
                                    });
                                }); } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", danger: true }, { children: t("common.delete") })) })) })] }));
            },
        },
    ];
    if (!data)
        return (0, jsx_runtime_1.jsx)("p", { children: "no data" });
    return ((0, jsx_runtime_1.jsxs)("div", { children: [modal ? ((0, jsx_runtime_1.jsx)(AddEditRoleDialog_1.default, { type: type, role: role, modalState: modal, setModalState: setModal })) : null, (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray([(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                            position: "absolute",
                            right: "250px",
                            marginTop: 15,
                            zIndex: 999,
                        }, onClick: function () {
                            setModal(true);
                            setType("add");
                        } }, { children: "Add new role" }))], (0, defaultDevExtremeGridComponents_1.default)({
                    summaryColumn: false,
                }), true) }))] }));
}
exports.default = Roles;
